<template>
  <div class="container" @click="onClick">
    <div class="treatmentLabel">
      <p>{{ props.name || '—' }}</p>
    </div>
    <div class="txt">
      <p>
        {{ descriptionText || DEFAULT_TEXT }}
      </p>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineEmits, defineProps } from 'vue'

const emit = defineEmits(['openDetailsModal'])

const props = defineProps({
  name: String,
  description: String,
})

const DEFAULT_TEXT = 'No information found.'
const descriptionText =
  computed(() => props.description !== 'null' ? props.description : DEFAULT_TEXT)

const onClick = () => {
  emit('openDetailsModal', props.name, props.description, 'Treatment')
}
</script>

<style lang="scss" scoped>
.container {
  transition: all linear 200ms;
  display: flex;
  width: 11.5rem;
  height: 7rem;
  padding: 0.9rem;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 9.72px;
  background: #F7F9FB;
  justify-content: flex-start;
  overflow: hidden;

  cursor: pointer;

  &:hover {
    background: var(--Grey200);
  }

  &:hover>.txt>p {
    color: var(--Grey800);
  }

  &:hover>.treatmentLabel {
    font-weight: 600;
  }
}

.treatmentLabel p {
  margin: 0;
  max-height: 1.7rem;
  color: var(--Black);
  font-size: 0.75rem;
  text-align: left;
  overflow-wrap: break-word;
  overflow: hidden;
  width: 9rem;
  text-transform: capitalize;

  //line clamping
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.txt p {
  margin-top: 0.4rem;
  overflow: hidden;
  color: var(--Grey600);
  font-size: 0.67rem;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  margin-bottom: 4px;
  width: 9.5rem;

  //line clamping
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
